$(document).ready(function(){
  checkSizeUnavailable();
/*   var url=$('.pagination__item:last').parent().prev().find('a').attr('href');
   $.get(url, function(data, status){
      if($(data).find('.module-collection-body .col').length == $(data).find('.module-collection-body .hide_it').length){
          $('.pagination__item:last').parent().prev().hide();
          if($('.pagination__item:last').parent().prev().prev().find("a").length == 0){
              $('.pagination__item:last').parent().prev().prev().hide();
          }
         if($(".pagination__item--current").parent().nextAll('li:visible').eq(0).find("a").hasClass("pagination__item--prev")){
            $(".pagination__item--current").parent().nextAll('li:visible').hide();
          }
      }     
    }); */
});

  // show message when click unavailable size
function checkSizeUnavailable() {
    let checkUnavailableSizes = document.querySelectorAll('.product-card-custom');
    checkUnavailableSizes.forEach(unavailableSize => {
        if (unavailableSize) {
          let unSizes = unavailableSize.querySelectorAll('.product-options-item-unavailable');
          unSizes.forEach((unSize) => {
            unSize.onclick = function() {
              let messageErr = unavailableSize.querySelector('.mess-unavailable-size');
              if(unavailableSize.querySelector('.mess-unavailable-size.hide_it')) {
                messageErr.classList.remove('hide_it');
              }
              setTimeout(() => {
                messageErr.classList.add('hide_it');
              }, 3000)
            }
          })
        }
    });
}
